import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { adminCopy } from '@/lib/copy';

import { clientsService } from '../services';
import type { UpdateClientNonPhiInput } from '../types';

import { clientsKeys } from './useClients';

export function useUpdateClient(id: string, options?: { silent?: boolean }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateClientNonPhiInput) => clientsService.updateNonPhi(id, input),
    onSuccess: async (client) => {
      qc.setQueryData(clientsKeys.detail(id), client);
      await qc.invalidateQueries({ queryKey: clientsKeys.lists() });
      // Silent for callers that own their own success toast (e.g. the client
      // Profile screen, which coalesces name + gender edits into one toast).
      if (!options?.silent) toast.success(adminCopy.clients.profile.updatedToast);
    },
  });
}
